const colors = {
  primary: {
    main: "#FC883F",
    light: "#a78bfa",
    dark: "#5b21b6",
    w_text:"#ffffff",
    
  },

  secondary: {
    main: "#FC6709",
  },

  success: {
    main: "#22c55e",
  },
};

export default colors;